import React from "react";

interface Props {
    color: string;
    fill?: string;
    size?: number;
}

export const Folder = (props: Props) => {
    const size = props.size ?? 24;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill={props.fill ?? "none"}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.8333 14.5383C15.8333 14.8821 15.7016 15.2119 15.4672 15.455C15.2328 15.6981 14.9149 15.8346 14.5833 15.8346H4.58334C4.25182 15.8346 3.93387 15.6981 3.69945 15.455C3.46503 15.2119 3.33334 14.8821 3.33334 14.5383V5.46427C3.33334 5.12047 3.46503 4.79075 3.69945 4.54765C3.93387 4.30454 4.25182 4.16797 4.58334 4.16797H7.70834L8.95834 6.11241H14.5833C14.9149 6.11241 15.2328 6.24899 15.4672 6.49209C15.7016 6.73519 15.8333 7.06491 15.8333 7.40871V14.5383Z"
                stroke={props.color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
